const { useLoading } = require("@context/LoadingContext")
const { useRef, Fragment } = require("react")

const IndiTrigger = ({setIndicator}) => {
  const {setLoading} = useLoading()
  setIndicator.current = setLoading
  
  return(
    <Fragment></Fragment>
  )
}

export default IndiTrigger